window._theme = window._theme || {};
document.addEventListener("DOMContentLoaded", function () {
    const searchInput = document.getElementById("blogSearch");
    const blogPosts = Array.from(document.querySelectorAll(".blog-post"));
    const searchResult = document.querySelector(".search-result");
    const searchQuerySpan = document.getElementById("searchQuery");
    const searchCountSpan = document.getElementById("searchCount");
    const searchResultText = document.getElementById("search-result-text");
    const loadMoreTrigger = document.getElementById("loadMoreTrigger");
    const promoImages = Array.from(document.querySelectorAll(".sidebar-promo-img"));
    let blogResults = document.getElementById("blogResults");

    let visibleCount = 4;
    const loadAmount = 4;

    function isMobileView() {
        return window.innerWidth < 768;
    }

    function searchBlog() {
        const query = searchInput.value.trim().toLowerCase();
        
        if (!query) {
            searchQuerySpan.textContent = "";
            searchCountSpan.textContent = "";
            searchResultText.textContent = '';
            blogPosts.forEach(post => post.style.display = "block");
            updateBlogList();
            return;
        }
    
        let matchCount = 0;
        
        blogPosts.forEach(post => {
            const title = post.getAttribute("data-title").toLowerCase();
            const tags = post.getAttribute("data-tags").toLowerCase();
            const matches = title.includes(query) || tags.includes(query);
            
            post.style.display = matches ? "block" : "none";
            if (matches) matchCount++;
        });
        
        searchResultText.textContent = 'Showing articles that mention';
        searchQuerySpan.textContent = `'${query}': `;
        searchCountSpan.textContent = matchCount || '';

        updateBlogList();
    }    

    function insertPromos(posts) {
        if (!isMobileView()) return posts;
        
        let result = [];
        let promoIndex = 0;

        for (let i = 0; i < posts.length; i++) {
            result.push(posts[i]);
            if ((i + 1) % 4 === 0 && promoImages.length) {
                let promoClone = promoImages[promoIndex % promoImages.length].cloneNode(true);
                promoClone.classList.add("promo-inserted");
                result.push(promoClone);
                promoIndex++;
            }
        }
        return result;
    }

    function updateBlogList() {
        document.querySelectorAll(".promo-inserted").forEach(el => el.remove());
        let filteredPosts = blogPosts.filter(post => post.style.display !== "none");
        let updatedList = insertPromos(filteredPosts.slice(0, visibleCount));
        
        blogResults.innerHTML = "";
        updatedList.forEach(item => blogResults.appendChild(item));
    }

    function loadMorePosts() {
        const hiddenPosts = blogPosts.slice(visibleCount, visibleCount + loadAmount);
        hiddenPosts.forEach(post => post.style.display = "block");
        visibleCount += hiddenPosts.length;

        updateBlogList();

        if (visibleCount >= blogPosts.length) {
            observer.disconnect();
            loadMoreTrigger.style.display = "none";
        }
    }
    
    const observer = new IntersectionObserver(entries => {
        if (entries[0].isIntersecting) {
            _theme.toggleLoading(1);
            setTimeout(function(){
                loadMorePosts();
                _theme.toggleLoading(0);
            }, 1000);
        }
    });

    observer.observe(loadMoreTrigger);
    searchInput.addEventListener("input", searchBlog);
    window.addEventListener("resize", updateBlogList);

    updateBlogList();
});
